<template>
  <div class="page">
    <mu-toast v-if="toast" v-bind:message="hintMsg" @close="hideToast" id="alertline" />
    <!--<mu-refresh-control :refreshing="refreshing" :trigger="trigger" @refresh="refresh" />-->
    <mu-appbar style="height: 1rem">
      <!--返回上一层-->
      <mu-icon value="keyboard_arrow_left" color="white" style="margin-top: 0.05rem" slot="left" v-on:click="goback()" />
      <div style="text-align:center; font-size:0.38rem;margin-top:">活动</div>
      <mu-icon value="keyboard_arrow_left" color="#27ba69" style="margin-bottom: -0.05rem" slot="right" />
    </mu-appbar>

    <!--主页面-->

    <div style="text-align:center;padding:0.2rem;" v-if='Isloading'>
      <div style='height: 1.65rem;'></div>
      <img src="../../../static/LoadingBest.gif" style=" width:1.2rem ;" />
    </div>
    <div style="background-color:#fff ; min-height:12.4rem"  v-else-if='!Isloading'  >

      <div style='height: 0.3rem;'></div>

      <!--<img v-bind:src="AllInfo" style=" width:100% " />-->

      <div v-on:click='LookDetail( item.id  )' v-for='(item,index) in AllInfo' :key="index">

        <div style="  width:6.9rem; margin:0  0.3rem; overflow:hidden ;    background-color:#fff;">

          <!--<img v-bind:src="item.url" style=" width:100% " />-->

          <div v-bind:style=" 'position:relative;background-image: url( ' + item.url +' ); background-repeat:no-repeat;  background-size: 100% ; height:4.5rem ' ">
            <div style=" width:100% ;height: 0.9rem ; position:absolute; bottom:0px;  background-color:#000 ; opacity:0.4 ; "></div>
            <div style="line-height: 0.36rem ;height: 0.52rem ;position: absolute; font-size:0.3rem; color:white ;  bottom: 14px; left:0 ; padding:0rem 0.2rem ;  ">
              {{(item.active_title).length>22 ? item.active_title.substring(0,22)+'...':item.active_title}}
              <br>
              <span style="font-size:0.26rem;color: #FFFAFA;">{{item.create_time}}</span>
            </div>
            <!-- <div style=" line-height: 0.7rem ;height: 0.7rem ;position: absolute; font-size:0.3rem; color:white ;  bottom:0px; right:0 ; padding:0rem 0.2rem ;  ">
              {{item.create_time}}
            </div> -->
          </div>

          <div style='height: 0.3rem;'></div>

        </div>
      </div>

      <!--<loadListTail mainTitle='此处无新闻' mainIcon='noInvoice' :noMore='loadState[this.activeTab].stop' :isLoading='loadState[this.activeTab].loading' :overZero='BreakfastList[activeTab].length > 0' />-->


      <div style='height: 0.1rem;'></div>

    </div>

  </div>
</template>





<script>
import api from '../../api'
import { mapGetters } from 'vuex'
import { mapMutations } from 'vuex'
import loadListTail from '../../components/loadListTail'
import Scroll from '../../utils/loading'
export default {
  data() {
    return {

      Isloading:true,

      AllInfo: '',

      activeTab: '1',


      dialog: false,
      toast: false,


      loadState: [
        {
          loading: false,
          stop: false
        },
        {
          loading: false,
          stop: false
        },
        {
          loading: false,
          stop: false
        }
      ],
      hintMsg: '',
      pageSize: 10,
      refreshing: false,
      trigger: null,
      couponCode: '',
      scroll: null,



    }
  },
  activated() {

    this.GetActivityYekCMS();


    // this.scroll.addHandler()
    // if (!this.g_currentOrder.freeVoucherInfo.useNotSee && !this.loadState[this.activeTab].loaded) {
    //   this.initData()
    // }
  },
  // mounted() {
  //   this.trigger = this.$el
  //   this.scroll = Scroll.Create(this, this.getData, this.pageSize, 7)
  // },
  // deactivated() {
  //   // this.getSelected()
  //   this.scroll.removeHandler()
  // },
  // components: {
  //   loadListTail
  // },
  methods: {
    ...mapMutations(['setG_currentOrder'
    ]),
    initData() {

      //清空显示数据
      this.BreakfastList = [[], [], []]

      //初始化本页控制数据、分页参数
      this.scroll.refresh()
    },
    refresh() {
      this.refreshing = true
      setTimeout(() => {
        this.refreshing = false
        this.initData()
      }, 2000)
    },


    //新闻单页    (int newsType, int pageSize, int pageIndex)
    GetActivityYekCMS() {
      var Tab = this.activeTab

      if (Tab == 1) Tab = 0;

      var that = this
      var params = new this.URLSearchParam();
      params.append('pagestar', 0);
      params.append('pageend', 20);
      //newsType  =  1 全部 23456 ~

      return new Promise(function(resolve, reject) {
        that.$http.post(api.GetActivityYekCMS(), params.toParam()).then((res) => {
          if (res.Result) {
            var temp = res.Data

            if (temp == null) {

              // resolve(null)
            }
            else {

              resolve(temp.length)

              that.AllInfo = res.Data

              that.Isloading =false;
            }
          }
          else {
            resolve(null)
            that.hintMsg = res.Message
            that.showToast()
          }
        })
      })

    },
    //三个分页
    handleTabChange(val) {

      this.activeTab = val;
      this.scroll.changeType(val)
    },

    // 跳转页面+传参
    LookDetail(IDCode) {

      var that = this
      
      var params = new this.URLSearchParam();
      params.append('activityId', IDCode);

      return new Promise(function(resolve, reject) {
        that.$http.post(api.GetActivityUrl(), params.toParam()).then((res) => {
          if (res.Result) {

            window.location.href = res.Data;

          }
          else {
            resolve(null)
            that.hintMsg = res.Message
            that.showToast()
          }
        })
      })



    },


    // 后退一页
    goback() {
      javascript: history.go(-1);
    },



    // 弹出层
    showToast() {
      this.toast = true
      if (this.toastTimer) clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toast = false }, 1500)
      if (this.hintMsg == '请先登录') {
        console.log(this.hintMsg)
        this.$store.dispatch('clearUser');
        this.toastTimer = setTimeout(() => { this.$router.push({ path: '/user/login' }); }, 1800)
      }
    },
    hideToast() {
      this.toast = false
      if (this.toastTimer) clearTimeout(this.toastTimer)
    },







  },
}
</script>







<style lang="less" scoped>
@import "../../assets/theme.less";

.mu-tabs {
  // 背景色
  background-color: #f5f5f5;
} // 未选中时候的颜色
.mu-tab-link {
  color: #999999;
  font-weight: bold;
} //  选中  分页的
.mu-tab-active {
  color: @primaryColor;
  font-weight: bold;
} // END 顶部标签变换
</style>







// WEBPACK FOOTER //
// ActivityList.vue?fa2f8b9c